import Head from "next/head";
import Link from "next/link";
import { Layout } from "@/components/Layout";
import { PageTitle } from "@/components/PageTitle";
import { SectionContainer } from "@/components/SectionContainer";

export default function About() {
  const pageTitle = "About";
  return (
    <>
      <Head>
        <title>{`${pageTitle} - Govern For California`}</title>
        <meta name="description" content="About Govern For California" />
      </Head>
      <Layout mobileTitle={pageTitle}>
        <PageTitle>
          <h2 className="text-3xl font-semibold tracking-tighter text-gray-900 sm:text-5xl lg:text-[2.9rem] xl:text-6xl">
            California needs{" "}
            <span className="pb-3 text-brand-text sm:pb-5">
              the best outcomes
            </span>{" "}
            for the{" "}
            <span className="pb-3 text-brand-text sm:pb-5">most people.</span>
          </h2>
        </PageTitle>

        {/* <SectionContainer
          bgColor={"bg-white"}
          className="pt-6"
          aria-label="Table of contents"
        >
          <ul className="text-base text-gray-800 sm:text-center lg:text-left lg:text-lg">
            <li className="mt-2">
              <a href="#who-we-are" className="body-link">
                Who we are
              </a>
            </li>
            <li className="mt-2">
              <a href="#how-we-operate" className="body-link">
                How we operate
              </a>
            </li>
          </ul>
        </SectionContainer> */}

        <SectionContainer
          bgColor={"bg-white"}
          className="pt-6"
          aria-label="Describing more areas of interest for California residents about the issues that impact them the most"
        >
          <div className="m-0 lg:col-span-2">
            {/* <a name="who-we-are"></a> */}
            {/* <h2 className="mt-2 text-2xl font-bold tracking-tight text-gray-900 sm:text-3xl">
              Who we are
            </h2> */}
            <p className="text-bas mt-5 sm:mx-auto sm:text-center lg:mx-0 lg:text-left lg:text-lg">
              For decades, special interests have wielded outsized influence
              over California’s governance, resulting in low-quality public
              services and ever-increasing spending with little to show for it.
              That’s because the general interest has been poorly represented.{" "}
              <span className="font-medium">
                Govern For California is a political philanthropy that works to
                counter special interest influence over California governments.{" "}
              </span>{" "}
              <Link className="body-link whitespace-nowrap" href="/who-we-are">
                Who we are →
              </Link>
            </p>
          </div>
        </SectionContainer>

        <SectionContainer
          bgColor={"bg-white"}
          aria-label="Describing the approach to the solution taken by Govern For California"
        >
          <div className="m-0 lg:col-span-2">
            <a name="how-we-operate"></a>
            <h2
              name="how-we-operate"
              className="mt-2 text-2xl font-bold tracking-tight text-gray-900 sm:text-3xl"
            >
              How we operate
            </h2>
            <p className="mt-5 text-base sm:mx-auto sm:text-center lg:mx-0 lg:text-left lg:text-lg">
              GFC raises money (more than $100 million since its launch in 2011)
              for political donations to candidates, ballot measures and other
              political philanthropies. Operating expenses and policy advocacy
              are supported by donations to a 501(c)(4) non-profit organization.
            </p>
          </div>
        </SectionContainer>
      </Layout>
    </>
  );
}
